import React from "react";
import { motion } from "framer-motion";
import { ArrowDownIcon } from "lucide-react";
import { CourtLines } from "../brand/CourtLines";
import { BoxMockup } from "../mockup/BoxMockup";
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section id="top" aria-labelledby="hero-title" className="on-light relative overflow-hidden bg-ice" data-id="element-123" data-mp="cy7d9874m0dd">
      <CourtLines className="pointer-events-none absolute -right-48 -top-32 h-[480px] w-[480px] text-cyan/20 lg:-right-40 lg:-top-40 lg:h-[820px] lg:w-[820px]" data-id="element-124" data-mp="mu0o8n575lt1" />

      <div className="container-x relative flex flex-col items-center gap-6 pb-12 pt-7 text-center sm:gap-8 sm:pb-16 sm:pt-12 lg:grid lg:grid-cols-2 lg:items-center lg:gap-12 lg:pb-24 lg:pt-20 lg:text-left" data-id="element-125" data-mp="qu2r2zmo4l9w">
        <div className="lg:order-1" data-id="element-126" data-mp="10knk87jkoxlf">
          <motion.h1 id="hero-title" initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease
        }} className="font-display text-[clamp(2.5rem,12vw,5.6rem)] font-extrabold uppercase leading-[0.9] text-navy lg:text-[clamp(3.4rem,6vw,5.8rem)]" data-id="element-127" data-mp="15ks5eavfeghz">
            Your whole year of floor hockey classes.
            <span className="block text-navy underline decoration-cyan decoration-[5px] underline-offset-[7px]" data-id="element-128" data-mp="3vuhgczmmv1pv">Ready.</span>
          </motion.h1>

          <a href="#offer" className="btn-primary mt-9 hidden lg:inline-flex" data-id="element-129" data-mp="3rv8o5z78rbwf">
            Explore the $27 bundle
            <ArrowDownIcon className="h-5 w-5" aria-hidden="true" data-id="element-130" data-mp="sgep5zg6nbsz" />
          </a>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease,
        delay: 0.1
      }} className="w-full lg:order-2" data-id="element-131" data-mp="nhaipgkn7s6c">
          <BoxMockup data-id="element-132" data-mp="el2vlvdrjrdn" />
        </motion.div>

        <a href="#offer" className="btn-primary w-full max-w-[420px] justify-center lg:hidden" data-id="element-133" data-mp="1b5trdx7lu6yy">
          Explore the $27 bundle
          <ArrowDownIcon className="h-5 w-5" aria-hidden="true" data-id="element-134" data-mp="16cs8le4a1na3" />
        </a>
      </div>
    </section>;
}